import React, { useState, useEffect, Fragment } from "react";
import {
  Card,
  Menu,
  Dropdown,
  Layout,
  Row,
  Col,
  Button,
  Modal,
  Input,
  Upload,
  Table,
  message,
  Space,
} from "antd";
import { Link,useLocation } from "react-router-dom";
import Axios from "axios";
import moment from "moment";
import { url } from "../../config/global";
import fileDownload from "js-file-download";
import {
  MoreOutlined,
  EditOutlined,
  DeleteOutlined,
  ExportOutlined,
  PlusOutlined,
  ImportOutlined,
  DownloadOutlined,
} from "@ant-design/icons";
import "./Calendar.less";

const { Search } = Input;
const { Content } = Layout;

function Role(props) {
  const [keyword, setKeyword] = useState("");
  const [role, setRole] = useState([]);
  const [data, setData] = useState([]);
  const [dataFailed, setDataFailed] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [pageSize, setPagesize] = useState(10);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isModalFailedVisible, setIsModalFailedVisible] = useState(false);
  const [modalFailed, setFailedModal] = useState(0);
  const [sort, setSort] = useState({
    sort: "description",
    order: "ascend",
  });
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const search = queryParams.get('search');

  const handleSearch = (value) => {
    setKeyword(value);

  };

  const showTotal = (total) => {
    return `Found total ${total} record`;
  };

  useEffect(() => {
    getData();
  }, [keyword, page, sort]);

  const handleTableChange = (pagination, filters, sorter) => {
    setPage(pagination.current);
    setPagesize(pagination.pageSize);
   
    setSort({
      sort: sorter.field,
      order: sorter.order,
    });
  };
  
  const closeModal = () => {
    setData({
      ...data,
      file: null,
    });
    setIsModalVisible(false);
    setIsModalFailedVisible(false);
  
  };
    const handleRemove = () => {
    setData({
      ...data,
      file: null,
    });
  };
    const handleBeforeUpload = (files) => {
    setData({
      ...data,
      file: files,
    });

    return false;
  };
  
  const onSaveData = () => {
    setLoading(true);

    let fd = new FormData();

    fd.append("file", data.file);

    Axios.post(`${url}/work-off-calendar/import`, fd, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${sessionStorage.getItem("token")}`,
      },
    })
      .then((res) => {
        if (res.data.type == "warning") {
          message.warning(res.data.message);
        } else {
          message.success(res.data.message);
          closeModal();
        }
        console.log(res.data)
        setFailedModal(true);
        if(res.data.data.length > 0 ) {
          setDataFailed(res.data.data)
          setIsModalFailedVisible(true)
        }
        getData();
      })
      .catch((err) => {
        if (err.response) {
          if (err.response.data.type === "error") {
            message.error(err.response.data.message);
          } else {
            const errorsKey = Object.keys(err.response.data.errors);
            const errors = err.response.data.errors;

            message.open({
              message: `Error!: ${err.response.data.message}`,
              description: (
                <div>
                  Error Details:
                  {errorsKey.map((error) => {
                    return <div>{errors[error][0]}</div>;
                  })}
                </div>
              ),
            });
          }

          if (err.response.status === 401) {
            sessionStorage.removeItem("token");
          }
        } else {
          message.error("Backend not yet Started");
        }
        setLoading(false);
      })
      .finally(() => {
        setLoading(false);
      });
  };
  const getData = () => {
    setLoading(true);
    Axios.get(`${url}/work-off-calendar`, {
      params: {
        keyword:keyword,
        columns: ["date","day",'description'],
        perpage: 10,
        page,
        sort: sort.sort,
        order: sort.order,
      },
      headers: {
        Authorization: `Bearer ${sessionStorage.getItem("token")}`,
      },
    })
      .then((res) => {
        setRole(res.data);
      })
      .catch((err) => {
        if (err.response) {
          message.error(err.response.data.message);
          if (err.response.status === 401) {
            sessionStorage.removeItem("token");
          }
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };
   const showModal = () => {
    setIsModalVisible(true);
  };
  const handleDelete = (id) => {
    Modal.confirm({
      title: "Are you sure?",
      content: (
        <div>
          <p>Deleted data cannot be restored</p>
        </div>
      ),
      okText: "Delete",
      showCancel: true,
      onCancel: () => {
        return;
      },
      cancelText: "Cancel",
      confirmLoading: loading,
      onOk: async () => {
        confirmDelete(id);
      },
    });
  };

  const confirmDelete = (id) => {
    setLoading(true);
    Axios.delete(`${url}/work-off-calendar/delete/${id}`, {
      headers: {
        Authorization: `Bearer ${sessionStorage.getItem("token")}`,
      },
    })
      .then((res) => {
        message.success(res.data.message);
        getData();
      })
      .catch((err) => {
        if (err.response) {
          message.error(err.response.data.message);
          if (err.response.status === 401) {
            sessionStorage.removeItem("token");
          }
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };
    const downloadTemplate = () => {
    Axios.get(`${url}/work-off-calendar/template`, {
      headers: {
        Authorization: `Bearer ${sessionStorage.getItem("token")}`,
      },
      responseType: "blob",
    }).then((res) => {
      fileDownload(res.data, "Template Master Work Off Day" + ".xlsx");
    });
  };
  const column_failed = [
    {
      title: "Row",
      dataIndex: "row",
      sorter: true,
    },
    {
      title: "Date",
      dataIndex: "date",
      render:(data,row) => {
        return row.date;
      },
      sorter: true,
    },
    {
      title: "Description",
      dataIndex: "description",
      sorter: true,
    },
    {
      title: "Reason",
      dataIndex: "reason",
      sorter: true,
    },
  ]
  const columns = [
    {
      title: "Date",
      dataIndex: "date",
      render:(data,row) => {
        return row.date;
      },
      sorter: true,
    },
    {
      title: "Day",
      dataIndex: "day",
      sorter: true,
    },
    {
      title: "Description",
      dataIndex: "description",
      sorter: true,
    },
    {
      title: "",
      dataIndex: "_id",
      align: "right",
      sorter: true,
      fixed: "right",
      width: 100,
      render: (id) => {
        return (
          <Fragment>
            <Dropdown
              className="pointer"
              overlay={
                <Menu>
                  <Menu.Item key="1">
                    <Link to={`/work-off-day/edit/${id}`}>
                      <EditOutlined /> Edit
                    </Link>
                  </Menu.Item>
                  <Menu.Item key="3">
                    <span onClick={() => handleDelete(id)}>
                      <DeleteOutlined />
                      Delete
                    </span>
                  </Menu.Item>
                </Menu>
              }
              trigger={["click"]}
            >
              <span className="pointer" onClick={(e) => e.preventDefault()}>
                <MoreOutlined />
              </span>
            </Dropdown>
          </Fragment>
        );
      },
    },
  ];

  return (
    <Fragment>
      <Row>
        <Col xs={24}>
          <Card
            type="inner"
            title="Work Off Calendar"
            extra={moment(new Date()).format("DD MMMM YYYY")}
          ></Card>
        </Col>
      </Row>

      <Content className="content">
        <Modal
        title="Import Master Work Off Calendar"
        visible={isModalVisible}
        footer={null}
        onCancel={closeModal}
      >
        <Card className="body-data">
          <div name="control-hooks">
            <div name="file" label="File">
              <Fragment>
                <Upload
                  onRemove={handleRemove}
                  beforeUpload={handleBeforeUpload}
                  fileList={[]}
                >
                  <Button style={{ marginBottom: 10 }}>
                    Pilih File <ExportOutlined />
                  </Button>
                </Upload>
                {data.file && (
                  <React.Fragment
                    children={[
                      <Button onClick={handleRemove} type="danger" ghost>
                        <DeleteOutlined />
                      </Button>,
                    ]}
                  >
                    {data.file.name ? data.file.name : data.file}
                  </React.Fragment>
                )}
              </Fragment>
            </div>
            <div>
              <Button
                loading={loading}
                onClick={onSaveData}
                type="primary"
                htmlType="submit"
                className="mr-button"
                style={{
                  marginRight: 10,
                }}
              >
                Unggah
              </Button>
              <Button htmlType="reset" onClick={handleRemove}>
                Batal
              </Button>
            </div>
          </div>
        </Card>
      </Modal>
      <Modal
        title="Failed Data"
        visible={isModalFailedVisible}
        footer={null}
        width={1200}
        onCancel={closeModal}
      >
        <Card className="body-data">
          <Table
              columns={column_failed}
              dataSource={dataFailed}
              rowKey={(data) => data._id}
              onChange={handleTableChange}
              pagination={{
                pageSize: 20,
                total: dataFailed.length,
                showSizeChanger: true,
                showTotal: showTotal,
              }}
              loading={loading}
            />
        </Card>
      </Modal>

     
        <Row>
          <Col xs={24}>
            <Card className="body-data">
              <Row type="flex" gutter={[10, 20]} justify="space-around">
                <Col xs={24} md={12} lg={18}>
                  <Link to="/work-off-day/create">
                    <Button type="primary">
                      <PlusOutlined />
                      Add Work Off Day
                    </Button>
                  </Link>
                  
                   <Link  style={{ marginLeft: 10, marginTop: 10 }}>
                    <Button type="primary"   onClick={showModal}>
                      <ImportOutlined />
                      Import Work Off Day
                    </Button>
                  </Link>

                   <Link  style={{ marginLeft: 10, marginTop: 10 }} >
                    <Button type="primary"  onClick={downloadTemplate}>
                      <DownloadOutlined />
                      Download Template
                    </Button>
                  </Link>
                </Col>
                <Col xs={24} md={12} lg={6} className="align-right">
                  <Search
                    placeholder="Search ..."
                    onSearch={(value) => handleSearch(value)}
                  />
                </Col>

                <Col xs={24}>
                  <Table
                    columns={columns}
                    dataSource={role.data}
                    rowKey={(data) => data._id}
                    onChange={handleTableChange}
                    pagination={{
                      pageSize: pageSize,
                      total: role.total,
                      showSizeChanger: true,
                      showTotal: showTotal,
                    }}
                    loading={loading}
                  />
                </Col>
              </Row>
            </Card>
          </Col>
        </Row>
      </Content>
    </Fragment>
  );
}

export default Role;
